<template>
    <div class="layout-menu2-wrap">
        <nav>
            <div class="nav-left">
                <span class="nav-left_font1 u-m-r-50"
                    > 校服订购服务平台</span
                >
                <img src="../../assets/img/phone.png" />
                <span class="nav-left_font2 u-m-l-10">{{commonInfo.tel || ''}}</span>
            </div>
            <div class="nav-right">
                <ul>
                    <li :class="[getClassActive('/')]" @click="toSwitch('/')">首页</li>
                    <li :class="[getClassActive('/introduce')]" @click="toSwitch('/introduce')">品牌介绍</li>
                    <li :class="[getClassActive('/brand')]" @click="toSwitch('/brand')">品牌优势</li>
                    <li :class="[getClassActive('/goods')]" @click="toSwitch('/goods')">产品订购</li>
                    <li :class="[getClassActive('/news')]" @click="toSwitch('/news')">新闻资讯</li>
                </ul>
                <div class="m-btns" v-if="!VUEX_IF_LOGIN">
                    <div class="m-btns-item m-btns-item-border" @click="$to_link('/login')">
                        <span>登录</span>
                    </div>
                    <div class="m-btns-item" @click="$to_link('/register')">
                        <span>注册</span>
                    </div>
                </div>
                <div class="u-flex" v-else>
                    <el-dropdown @command="commandFun" v-if="!VUEX_USER_INFO.is_renzheng">
                        <span class="m-font1">
                            个人中心<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{type:'route',path:'/centerIndex'}">个人中心</el-dropdown-item>
                            <el-dropdown-item :command="{type:'out'}">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown @command="commandFun" v-else>
                        <span class="m-font1">
                            {{VUEX_USER_INFO.grade_name}}{{VUEX_USER_INFO.class_name}}{{VUEX_USER_INFO.stu_name}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{type:'route',path:'/centerIndex'}">个人中心</el-dropdown-item>
                            <el-dropdown-item :command="{type:'out'}">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </div>
                <div class="m-car" @click="$to_link('/centerCarShop')">
                    <img src="../../assets/img/icon-car.png" alt="" />
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations,
    mapActions
} from 'vuex'
export default {
    data() {
        return {
            commonInfo:{}
        };
    },
    created() {
       this.getCommonDataFun()
    },
    computed: {
        ...mapState([
            'VUEX_IF_LOGIN',
            'VUEX_USER_INFO'
        ]),
        getClassActive: function () {
            return (url) => {
                let route = this.$route.path;
                if (url == route) {
                    return "li-active";
                } else {
                    return "";
                }
            };
        },
    },
    methods: {
        //获取公众配置
        getCommonDataFun(){
            this.$http.get('index_getCommonContent',{},{cache:true}).then(res=>{
                if(res.code == 1){
                    this.commonInfo = res.data
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        toSwitch(url){
            this.$to_redirect(url)
        },
        commandFun(e){
            switch(e.type){
                case 'route':
                    this.$to_link(e.path);
                break;
                case 'out':
                    this.$store.dispatch('vuex_login_out');
                    this.$to_redirect('/')
                break;
            }
        },
    },
};
</script>
<style lang="scss">
.layout-menu2-wrap {
    width: 100%;
    min-width: $width;
    height: 70px;
    background: #0073DF;
    nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: $width;
        height: 100%;
        margin: 0 auto;
        .nav-left {
            display: flex;
            align-items: center;
            .nav-left_font1 {
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                line-height: 31px;
                color: #fff;
            }
            .nav-left_font2 {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 21px;
                color: #fff;
            }
        }
        .nav-right {
            display: flex;
            align-items: center;
            height: 100%;
            ul {
                display: flex;
                height: 100%;
                li {
                    display: flex;
                    align-items: center;
                    position: relative;
                    cursor: pointer;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 19px;
                    color: rgba($color: #fff, $alpha: 0.9);
                    padding: 0 25px;
                    &:hover {
                        color: #fff;
                        font-weight: bold;
                    }
                }
                .li-active {
                    color: #fff;
                    font-weight: bold;
                }
            }
            .m-btns {
                display: flex;
                border: 1px solid #fff;
                margin-left: 25px;
                .m-btns-item {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 48px;
                    height: 24px;
                    cursor: pointer;
                    span {
                        font-size: 14px;
                        color: #fff;
                        user-select: none;
                    }
                    &:active {
                        opacity: 0.6;
                    }
                }
                .m-btns-item-border {
                    border-right: 1px solid #fff;
                }
            }
            .m-font1{
                font-size: 14px;
                color: #fff;
                line-height: 20px;
                cursor: pointer;
            }
            .m-car {
                display: flex;
                width: 20px;
                height: 20px;
                cursor: pointer;
                margin-left: 20px;
                &:active {
                    opacity: 0.6;
                }
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>
